<div [formGroup]="multiSelectGroup" class="multi-select-container">
    <ng-select
        [clearable]="clearable"
        [dropdownPosition]="'bottom'"
        [closeOnSelect]="false"
        [items]="mutableItems"
        [multiple]="true"
        [placeholder]="placeholder"
        [title]="tooltip ? tooltip : ''"
        appendTo="body"
        [bindLabel]="bindLabel"
        [formControl]="selectedItemsControl"
    >
    </ng-select>
</div>
